import { Link } from "react-router-dom";
import { Atmosphere, Ribbons } from "@/components/Art";
import { Cta } from "@/components/Cta";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo("Page not found", "This page doesn't exist.", { noindex: true });
  return (
    <section className="relative flex min-h-[90svh] items-center overflow-hidden pt-28" data-testid="not-found">
      <Atmosphere />
      <Ribbons id="nf" className="pointer-events-none absolute inset-0 h-full w-full opacity-50" />
      <div className="wrap relative text-center">
        <img src="/brand/emblem-256.png" alt="" aria-hidden="true" className="float-slow mx-auto h-28 w-28" />
        <p className="mt-8 font-mono text-sm tracking-[0.3em] text-si-cyan">ERROR 404</p>
        <h1 className="mt-4 text-[clamp(2.4rem,6vw,4.5rem)] font-extrabold tracking-[-0.03em]">This page doesn't exist.</h1>
        <p className="mx-auto mt-4 max-w-md text-lg text-si-muted">The idea may have moved — or it hasn't been built yet.</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Cta to="/" testId="nf-home">Back Home</Cta>
          <Cta to="/ventures" variant="secondary" testId="nf-ventures">Ventures</Cta>
          <Link to="/contact" className="inline-flex h-12 items-center px-4 font-semibold text-si-muted hover:text-si-text" data-testid="nf-contact">Contact</Link>
        </div>
      </div>
    </section>
  );
}
